import s from './ContainerCol.module.css';
import st from '../GraphContainer/GraphContainer.module.css';
import { RangeForm } from '../RangeForm/RangeForm';
export const RangeContainer = () => {
  return (
    <div className={s.containerCol}>
      <h1 className={st.blueTextTitle}>
        Compare the prices of providers on our calculator
      </h1>
      <h3 className={st.blackText}>
        Calculate the cost of storing information with pay-as-you-go
      </h3>
      <p>
        Compare the prices of providers on the market using our service in a
        visual price comparison calculator per gigabyte of information. <br />
        <strong>
          Click on the column of the provider and you will find out the price of
          using the storage for a month or a year!
        </strong>
        <br />
        We care about the customer experience and strive for constant innovation
        to help businesses and developers create a faster, safer, and more
        reliable Internet. <br />
        Our calculator was created in 2023 with a simple idea to help developers
        provide content at a low cost. From there, it became a much more
        ambitious vision to help shape the Internet.
        <br />
        <strong>
          Prices do not correspond to reality and are not related to the
          providers taken in the example of this application!!!
        </strong>
      </p>
      <RangeForm />
    </div>
  );
};
